<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-04-13 05:01:00
    Description : 分站赛
  -->
  <div class="main">
    <div class="background">
      <div class="logo" :style="{ background: `url(${logo})` }"></div>
      <div class="title">所有作品受版权保护</div>
    </div>
    <div
      class="check-box"
      :style="{
        background:
          areaIndex > -1
            ? `url(${baseUrl}${background}) 0% 0% / 100% 100% no-repeat`
            : '#ffffff',
      }"
    >
      <div
        v-if="areaIndex === -1"
        class="image"
        :style="{ background: `url(${checkboxLogo})` }"
      ></div>
      <div v-else class="area-text">
        {{
          `${areaList[areaIndex].text} | ${areaList[areaIndex].pinyin} · ${areaList[areaIndex].startTime} - ${areaList[areaIndex].endTime}`
        }}
      </div>
      <el-dropdown @command="yearBarClick" trigger="click">
        <span
          class="el-dropdown-link select"
          :style="{ background: isSelect ? '#ffa100' : '#1a1a1a' }"
        >
          选 择 分 站
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, i) in areaList"
            :key="item.id"
            :command="i"
            style="width: 474px"
          >
            {{
              `${item.text} | ${item.pinyin} · ${item.startTime} - ${item.endTime}`
            }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="white-border"></div>
    </div>
    <div style="text-align: center; margin-bottom: 70px">
      <img src="@/assets/images/gaia48/bolang.png" />
    </div>
    <div
      class="optimal"
      v-for="(item, i) in mostList"
      :key="i"
      v-if="awardsRecordList.length > 0 && item.id === optimalIndex"
    >
      <div class="gaia-48-bar" :style="{ background: `url(${gaia48bar})` }">
        <div style="width: 1300px; margin: 0 auto">
          <div>
            <img style="width: 280px; height: 130px" :src="item.logo" />
          </div>
          <div class="most-item">
            <div class="cover">
              <img :src="item.cover" />
            </div>
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="people">
                {{ item.people }}
              </div>
              <div class="introduction">
                <div v-html="item.introduction"></div>
              </div>
              <div
                class="play"
                @click="jumpTo(`/desktop/gaia-48/detail?id=${item.id}`)"
              >
                <img :src="playBtn" />
              </div>
            </div>
            <div class="fraction">
              <img style="width: 200px; height: 90px" :src="item.logo2" />
              <br />
              <ul>
                <li>最后得分：{{ item.artScore }} <span></span></li>
                <li>剧本：{{ item.avgScore }}<span></span></li>
                <li>叙事完整性：{{ item.clipScore }} <span></span></li>
                <li>拍摄成熟度：{{ item.directorscore }}<span></span></li>
                <li>剪辑流畅度：{{ item.photogrephyScore }} <span></span></li>
                <li>视觉优美性：{{ item.scriptScore }}<span></span></li>
                <li>技术先进性：{{ item.showScore }} <span></span></li>
                <li>整体艺术表现：{{ item.soundSore }}<span></span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="optimal-radio">
      <div
        v-for="(item, i) in awardsRecordList"
        :key="item.id"
        class="item"
        :class="{ active: optimalIndex === item.hourWorks.id }"
        @click="optimalIndex = item.hourWorks.id"
      >
        {{ item.awards.name }}
      </div>
    </div>
    <div class="all-works">
      <div class="h1">全部作品</div>
      <div class="item" v-for="(item, i) in worksList" :key="item.id">
        <div
          class="cover"
          :style="{
            background: `url(${baseUrl + item.cover}) `,
            backgroundSize: '100% 100%',
          }"
          @click="openDetail(item.id)"
        ></div>
        <good-one
          :theme="item.like ? 'filled' : 'outline'"
          size="40"
          fill="#ffa100"
          style="cursor: pointer"
          @click="worksAgree(item.id)"
        />
        <div class="votes">投票 ({{ item.likeCount }})</div>
        <div class="title">{{ item.title }}</div>
        <div class="number">No. {{ item.number }}</div>
      </div>
      <div style="text-align: center">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="page.pageSize"
          :total="page.total"
          :current-page="page.pageIndex"
          @current-change="getShowWorks"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getShowWorks,
  getAreas,
  getAreaDetail,
  worksAgree,
} from "@/api/newgaia48";
import { GoodOne } from "@icon-park/vue";
export default {
  components: {
    GoodOne,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      logo: require("../../assets/images/gaia48/分站赛.png"),
      checkboxLogo: require("../../assets/images/gaia48/locations.png"),
      checkbox: 0,
      gaia48bar: require("../../assets/images/gaia48/gaia48-bar.png"),
      playBtn: require("../../assets/images/gaia48/play-btn.png"),
      mostList: [
        {
          logo:
            "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/image/cover/u7714/20190531-144630.png",
          cover:
            "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/15159505581441aeb.jpg",
          title: "朵儿",
          people:
            "导演：夏梦怡 / 摄影：董潇涵 / 编剧：夏梦怡 / 副摄影：李涛 / 摄影助理：郭翔宇 / 灯光：焦保全 钱陈虎 / 录音：李森 高小雷 / 场记：刘爽 孟明璐 / 统筹：若虚 / 制片：何宇 / 化妆：公丽君 / 剧务：吴欣 杜宇非 周建 / 纪录片摄影：王茁旭 / 后期剪辑：夏梦怡 李涛 / 调色：冬菇童鞋 / 声音制作：韩志超",
          introduction:
            "朵儿妈为了孩子好，将自己的女儿朵儿送去学习提琴，在学习的过程中，老师对她做出一些奇怪的举动，并告诉朵儿，这是他们之间的小秘密。一个小小的木推子成为老师贿赂孩子的工具。当一天的学习结束了，妈妈接拿着木推子的朵儿回家，和她们擦肩而过的，是另一对拿着木推子的父女......",
        },
        {
          logo:
            "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/image/cover/u7714/20190531-144643.png",
          cover:
            "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/15353628831524d12.jpg",
          title: "69",
          people:
            "导演：郭东勋 / 编剧：翟瀚彧 / 摄影：郭东勋 陈玥 / 剪辑：郭东勋 / 执行导演：徐丝 /服装造型：陈玥 / 制片：李奇旺 / 收音：李奇旺 / 统筹：周游 /道具：周游 /美术：周游 / 场记：翟瀚彧 / 灯光：刘烨辰 /主演：林晓珊 / 灯光助理：李威",
          introduction:
            "有时候前与后，上与下，阴和阳，沦陷和重生，本质上并没有什么区别。那么到底是什么在定义着人的生活呢？是命运吗？是社会吗？是自己吗？哑巴小珊从不奢望能定义自己的生活，但失去自由之后，命运竟又来向她索取更多。来路太苦太长，她已经看不清自己的心了。",
        },
      ],
      optimalIndex: 0,
      areaList: [],
      areaIndex: -1,
      areaId: -1,
      page: {
        pageIndex: 1,
        pageSize: 9,
        total: 0,
      },
      worksList: [],
      background: "",
      isSelect: false,
      awardsRecordList: [], // 获奖列表
    };
  },
  created() {
    this.getShowWorks();
    this.getAreas();
  },
  methods: {
    yearBarClick(i) {
      this.isSelect = true;
      this.areaIndex = i;
      this.areaId = this.areaList[i].id;
      this.background = this.areaList[i].cover;
      this.getShowWorks();
    },
    getShowWorks(num = 1) {
      this.page.pageIndex = num;
      const data = {
        keyword: "",
        oderType: "time",
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize,
        year: this.areaId,
      };
      getShowWorks(data).then((res) => {
        console.log(res);
        this.worksList = res.allHourWorksDtos;
        this.getAreaDetail();
        this.page = res.page;
      });
    },
    currentChange() {
      console.log("currentChange");
    },
    getAreas() {
      getAreas().then((res) => {
        this.areaList = res.areaList;
      });
    },
    getAreaDetail() {
      getAreaDetail(this.areaId).then((res) => {
        console.log(res);
        this.awardsRecordList = res.awardsRecordList;
        this.optimalIndex = this.awardsRecordList[0].hourWorks.id;
        this.mostList = this.awardsRecordList.map((el) => {
          return {
            id: el.hourWorks.id,
            logo: this.baseUrl + el.awards.awardsCover,
            logo2: this.baseUrl + el.awards.medalCover,
            title: el.hourWorks.title,
            cover: this.baseUrl + el.hourWorks.cover,
            people: el.hourWorks.creators
              .map((el) => {
                return `${el.position}：${el.name}`;
              })
              .join(" / "),
            introduction: el.hourWorks.description,
            artScore: (el.artScore / 100).toFixed(2),
            avgScore: (el.avgScore / 100).toFixed(2),
            clipScore: (el.clipScore / 100).toFixed(2),
            directorscore: (el.directorscore / 100).toFixed(2),
            photogrephyScore: (el.photogrephyScore / 100).toFixed(2),
            scriptScore: (el.scriptScore / 100).toFixed(2),
            showScore: (el.showScore / 100).toFixed(2),
            soundSore: (el.soundSore / 100).toFixed(2),
          };
        });
      });
    },
    openDetail(id) {
      open(`/desktop/gaia-48/detail?id=${id}`);
    },
    worksAgree(id) {
      worksAgree(id).then((res) => {
        this.getShowWorks(this.page.pageIndex);
        if (res.msg.includes("cancel")) {
          this.$message.success("取消点赞成功");
        } else {
          this.$message.success("点赞成功");
        }
      });
    },
    jumpTo(url) {
      open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding-top: 70px;
  // background: #888;
}
.logo {
  display: inline-block;
  width: 220px;
  height: 63px;
}
.title {
  font-size: 14px;
  color: #000;
  letter-spacing: 8px;
}
.background {
  width: 100%;
  min-width: 1300px;
  height: 300px;
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/image/cover/u6100/20181213-111144.jpeg)
    no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 120px;
  margin-top: 10px;
}
.year-bar {
  min-width: 1300px;
  width: 100%;
  height: 66px;
  line-height: 66px;
  background: #414141;
  text-align: center;
}
.select {
  padding: 8px 188px 8px 140px;
  font-size: 20px;
  border-radius: 4px;
  background: #1a1a1a;
  padding-left: 188px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}
.image {
  width: 225px;
  height: 80px;
  margin: -15px auto 35px;
  background-color: #ffffff;
}
.area-text {
  height: 80px;
  line-height: 70px;
  margin: 0 auto 20px;
  letter-spacing: 10px;
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
}
.optimal {
  width: 100%;
  min-width: 1300px;
  height: 820px;
  background: #1a1a1a;
}
.gaia-48-bar {
  width: 100%;
  height: 130px;
}
.el-dropdown-menu__item {
  font-size: 20px;
}
.most-item {
  display: flex;
  padding: 100px 40px 140px;
  .cover {
    width: 294px;
    height: 410px;
    border: 4px solid #3f3f3f;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    width: 700px;
    padding: 0 5%;
    .title {
      font-size: 60px;
      color: #ffffff;
    }
    .people {
      min-height: 75px;
      max-height: 75px;
      font-size: 20px;
      margin-top: 30px;
      margin-bottom: 34px;
      line-height: 1.2;
      color: #fff;
      overflow: hidden;
    }
    .introduction {
      font-size: 16px;
      color: #b2b2b2;
      line-height: 1.5;
      margin-bottom: 88px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      max-height: 110px;
    }
    .play {
      display: block;
      width: 240px;
      height: 50px;
      line-height: 65px;
      background: #404040;
      text-align: center;
      cursor: pointer;
    }
  }
  .fraction {
    width: 240px;
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 10px;
    color: gray;
  }
}
.optimal-radio {
  display: flex;
  margin: -60px auto 60px;
  width: 700px;
  justify-content: space-around;
  background: #1a1a1a;
  .item {
    width: auto;
    padding-bottom: 10px;
    font-size: 16px;
    margin: 0 10px 0;
    white-space: nowrap;
    color: #5f5f5f;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
  }
  .item.active {
    border-bottom: solid 5px #ffa100;
    color: #ffa100;
    transition: all 0.2s;
  }
}
.all-works {
  width: 1300px;
  margin: 0 auto;
  padding: 100px 40px 140px;
  .h1 {
    width: 160px;
    font-size: 24px;
    margin: 0 0 40px;
    padding-bottom: 10px;
    font-weight: bold;
    color: #000000;
    border-bottom: solid 6px #ffa100;
  }
  .item {
    display: inline-block;
    width: 300px;
    height: 620px;
    margin-right: 160px;
    text-align: center;
    cursor: pointer;
    .cover {
      width: 100%;
      height: 420px;
      margin-bottom: 10px;
      border: 1px solid #3f3f3f;
      background: #000000;
    }
    .title {
      padding-top: 18px;
      font-size: 28px;
      font-weight: 400;
      color: #000000;
    }
    .votes {
      font-size: 14px;
      color: gray;
    }
    .number {
      font-size: 20px;
      color: #000;
    }
  }
  .item:nth-child(3n + 1) {
    margin-right: 0;
  }
}
.check-box {
  width: 1300px;
  height: 260px;
  margin: -70px auto 100px;
  box-shadow: 0px 22px 29px 0px rgba(192, 192, 192, 0.38);
  padding: 70px 0 0;
  font-weight: 300;
  background: #fff;
  text-align: center;
  border-radius: 6px;
}
.white-border {
  position: relative;
  top: -176px;
  border-radius: 4px;
  opacity: 0.75;
  left: 20px;
  width: 1260px;
  height: 220px;
  border: #ffffff solid 1px;
  pointer-events: none;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ffa200;
}
</style>